import { FC } from 'react'
import shallow from 'zustand/shallow'
import { useTranslation } from 'react-i18next'
import { nanoid } from 'nanoid'
import TextArea from 'antd/lib/input/TextArea'

import PerText from '../Text'
import PerSpacer from '../Spacer'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { useAuth } from '../../../context/auth-context'
import { SmartAvatar } from '../../../modules/avatar/SmartAvatar'
import { useDateTime } from '../../../shared/useDateTime'
import { useTargetsModalStore } from './TargetsModalStore'

const MAX_CHARS = 4000

export const TargetsModalCommentInput: FC = () => {
  const { user } = useAuth()
  const { t } = useTranslation()
  const { formatDateToUtcString } = useDateTime(user)

  const [addComment, commentFromInput, setCommentFromInput] = useTargetsModalStore(
    (state) => [state.addComment, state.commentFromInput, state.setCommentFromInput],
    shallow,
  )

  const handleComment = () => {
    const comment = {
      id: nanoid(),
      text: commentFromInput as string,
      date: formatDateToUtcString(new Date()),
      isNewComment: true,
      author: { id: user.employeeId, firstName: user.firstName, lastName: user.lastName, avatarUrl: user.avatarUrl },
    }

    addComment(comment)
  }

  return (
    <PerFlexRow align="top" className="per-newNote" noWrap mt="m" mb="l">
      <PerFlexRow align="middle" className="per-newNote--user per-comments--user-wrapper" noWrap>
        <SmartAvatar employeeId={user.employeeId} firstName={user.firstName} lastName={user.lastName} />
        <PerSpacer ml="xs" mr="l" className="per-comments--user">
          <PerText fontWeight="bold" className="per-comments--user-name">
            {user.firstName}
          </PerText>
          <PerText appearance="flowing-text" color="secondary">
            {t('global.today')}
          </PerText>
        </PerSpacer>
      </PerFlexRow>
      <PerFlexRow align="top" justify="start" noWrap className="per-comments--input" ml="s">
        <TextArea
          name="text"
          placeholder="Comment"
          value={commentFromInput}
          maxLength={MAX_CHARS}
          data-e2e-newnote-input
          onChange={({ target: { value } }) => setCommentFromInput(value || undefined)}
        />
        <PerButtonCircle
          icon="check_stroke"
          variant="pastel"
          color="success"
          ml="xs"
          size="small"
          tooltip={t('okr.objective.notes.add')}
          onClick={handleComment}
          style={{ margin: 0 }}
          disabled={!commentFromInput}
          data-e2e-addnote-button
        />
      </PerFlexRow>
    </PerFlexRow>
  )
}
